module.exports = __webpack_public_path__ + "img/airplane.6953b350.png";